var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeIamge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 712.541,
    height: 674.867,
    viewBox: "0 0 712.541 674.867",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 239.667,
    y: 155.404,
    width: 236.368,
    height: 263.914,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    x: 239.231,
    y: 409.93,
    width: 237.255,
    height: 264.937,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "d"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "d"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    x: 465.779,
    y: 0,
    width: 246.762,
    height: 275.915,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "f"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "f"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.806,
    height: 52.713,
    fill: "#9d9d9c"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.014,29.711a3.932,3.932,0,1,0,3.931-3.931,3.932,3.932,0,0,0-3.931,3.931",
    transform: "translate(-216.014 -25.78)",
    fill: "#f19117"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.014,219.653a3.932,3.932,0,1,0,3.932-3.932,3.932,3.932,0,0,0-3.932,3.932",
    transform: "translate(-216.014 -215.721)",
    fill: "#f19117"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.072,219.652A3.932,3.932,0,1,0,30,215.72a3.932,3.932,0,0,0-3.928,3.932",
    transform: "translate(-26.072 -215.72)",
    fill: "#f19117"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.072,29.711A3.932,3.932,0,1,0,30,25.779a3.932,3.932,0,0,0-3.928,3.932",
    transform: "translate(-26.072 -25.779)",
    fill: "#f19117"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.043,128.056a3.932,3.932,0,1,0,3.932-3.932,3.932,3.932,0,0,0-3.932,3.932",
    transform: "translate(-121.043 -124.124)",
    fill: "#f19117"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "o",
    x: 0,
    y: 0,
    width: 246.762,
    height: 275.915,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "p"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "p"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "q"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57.521,
    height: 52.371,
    fill: "#9d9d9c"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.572,88.518a2.612,2.612,0,1,0,2.612-2.612,2.612,2.612,0,0,0-2.612,2.612",
    transform: "translate(-108.572 -85.906)",
    fill: "#f19117"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.039,34.319a2.236,2.236,0,1,0,1.616-.691,2.236,2.236,0,0,0-1.616.691",
    transform: "translate(-140.42 -33.628)",
    fill: "#f19117"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "u"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.056,221.555a2.236,2.236,0,1,0,1.616-.691,2.236,2.236,0,0,0-1.616.691",
    transform: "translate(-141.436 -220.864)",
    fill: "#f19117"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "v"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.4,126.506a2.236,2.236,0,1,0,1.616-.691,2.236,2.236,0,0,0-1.616.691",
    transform: "translate(-275.785 -125.815)",
    fill: "#f19117"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.69,129.368a2.236,2.236,0,1,0,1.616-.691,2.236,2.236,0,0,0-1.616.691",
    transform: "translate(-6.07 -128.677)",
    fill: "#f19117"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "x"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.518,
    height: 42.591,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "y"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.014,30.436a4.656,4.656,0,1,0,4.656-4.656,4.656,4.656,0,0,0-4.656,4.656",
    transform: "translate(-216.014 -25.78)",
    fill: "#f19117"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "z"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.014,28.46a2.68,2.68,0,1,0,2.68-2.68,2.68,2.68,0,0,0-2.68,2.68",
    transform: "translate(-216.014 -25.78)",
    fill: "#f19117"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1092.385 -265.138)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1092.39, 265.14)",
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.525,0a20,20,0,0,1,17.321,10l51.48,89.184a20,20,0,0,1,0,20l-51.48,89.184a20,20,0,0,1-17.321,10H74.573a20,20,0,0,1-17.321-10L5.771,119.182a20,20,0,0,1,0-20L57.251,10A20,20,0,0,1,74.573,0Z",
    transform: "translate(467.04 158.31) rotate(90)",
    fill: "#fdb12a"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1340.611 677.975)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -248.23, -412.84)",
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.293,0a20,20,0,0,1,17.321,10L247.35,99.628a20,20,0,0,1,0,20l-51.736,89.627a20,20,0,0,1-17.321,10H74.829a20,20,0,0,1-17.321-10L5.772,119.625a20,20,0,0,1,0-20L57.507,10A20,20,0,0,1,74.829,0Z",
    transform: "translate(467.49 412.84) rotate(90)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(27.626 83.399)",
    fill: "#f19117",
    fontSize: 25,
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Data Services")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(18.973 117.334)",
    fill: "rgba(33,33,33,0.87)",
    fontSize: 16,
    fontFamily: "ArialMT, Arial"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "IoT, Big Data &amp; Corporate")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(29.641 135.334)",
    fill: "rgba(33,33,33,0.87)",
    fontSize: 16,
    fontFamily: "ArialMT, Arial"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Data for Single Source")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(81.231 153.334)",
    fill: "rgba(33,33,33,0.87)",
    fontSize: 16,
    fontFamily: "ArialMT, Arial"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "of Truth")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(55.234 178.724)",
    fill: "#9d9d9c",
    fontSize: 14,
    fontFamily: "ArialMT, Arial"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Capture, Process,")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(40.075 194.724)",
    fill: "#9d9d9c",
    fontSize: 14,
    fontFamily: "ArialMT, Arial"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Sync with Microservice"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1567.166 268.045)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -474.78, -2.91)",
    filter: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.527,0a20,20,0,0,1,17.321,10l54.48,94.381a20,20,0,0,1,0,20l-54.48,94.381a20,20,0,0,1-17.321,10H77.573a20,20,0,0,1-17.321-10L5.772,124.38a20,20,0,0,1,0-20L60.252,10A20,20,0,0,1,77.573,0Z",
    transform: "translate(703.54 2.91) rotate(90)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(57.011 94.983)",
    fill: "#f19117",
    fontSize: 25,
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "IT Services")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(51.225 134.883)",
    fill: "rgba(33,33,33,0.87)",
    fontSize: 16,
    fontFamily: "ArialMT, Arial"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Cloud-based 24/7")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(22.346 152.883)",
    fill: "rgba(33,33,33,0.87)",
    fontSize: 16,
    fontFamily: "ArialMT, Arial"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Agnostic / specific / Mixed")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(36.755 189.117)",
    fill: "#9d9d9c",
    fontSize: 14,
    fontFamily: "ArialMT, Arial"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Infrastructure Worry-Free"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1383.55 596.563)",
    fill: "#7b7b7b",
    fontSize: 15,
    fontFamily: "ArialMT, Arial"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A zDevOps Delivery")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1410.912 629.318)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.574,
    cy: 39.934,
    rx: 39.574,
    ry: 39.934,
    transform: "translate(0 0)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.171 13.577)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.949,54.885l.13-.2a26.23,26.23,0,0,0,0-28.418l-.131-.2.133-.2a5.481,5.481,0,1,0-2.388,2.021l.3-.132.17.277a23.75,23.75,0,0,1,0,24.9l-.17.277-.3-.132a5.5,5.5,0,0,0-7.242,7.244l.13.3-.276.169a24.034,24.034,0,0,1-22.56,1.249,1.279,1.279,0,1,0-1.088,2.315,26.475,26.475,0,0,0,25.41-1.662l.2-.13.2.133a5.494,5.494,0,0,0,7.609-7.611Zm-4.46-29.1a2.939,2.939,0,1,1,2.939-2.939,2.939,2.939,0,0,1-2.939,2.939m0,35.262a2.939,2.939,0,1,1,2.939-2.939,2.939,2.939,0,0,1-2.939,2.939",
    transform: "translate(-63.456 -14.124)",
    fill: "#9d9d9c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.464,39.194a5.422,5.422,0,0,0-4.9-.251l-.3.132L6.1,38.8a23.751,23.751,0,0,1,0-24.9l.17-.277.3.132a5.5,5.5,0,0,0,7.243-7.244l-.13-.3.276-.169a24.089,24.089,0,0,1,22.248-1.4,1.279,1.279,0,0,0,1.055-2.331,26.608,26.608,0,0,0-25.068,1.82l-.2.13-.2-.132a5.5,5.5,0,0,0-7.611,7.609l.133.2-.131.2a26.232,26.232,0,0,0,0,28.417l.131.2-.133.2a5.5,5.5,0,1,0,10.093,3.015,5.428,5.428,0,0,0-2.8-4.785m-2.7-33.4a2.939,2.939,0,1,1-2.94,2.94,2.939,2.939,0,0,1,2.94-2.94m0,41.141a2.939,2.939,0,1,1,2.939-2.939,2.939,2.939,0,0,1-2.939,2.939",
    fill: "#9d9d9c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.102 4.786)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.863,
    height: 7.863,
    fill: "#f19117"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.102 40.048)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.863,
    height: 7.863,
    fill: "#f19117"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.84 40.048)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.863,
    height: 7.863,
    fill: "#f19117"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.84 4.786)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.863,
    height: 7.863,
    fill: "#f19117"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.236,106.015a15.722,15.722,0,0,0,0-22.209,1.308,1.308,0,0,0-1.851,1.85,13.1,13.1,0,0,1,0,18.508,1.309,1.309,0,1,0,1.851,1.851",
    transform: "translate(-154.729 -67.935)",
    fill: "#9d9d9c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.113,85.656A1.309,1.309,0,1,0,62.262,83.8a15.722,15.722,0,0,0,0,22.209,1.309,1.309,0,1,0,1.851-1.851,13.1,13.1,0,0,1,0-18.508",
    transform: "translate(-46.964 -67.935)",
    fill: "#9d9d9c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.3,118.547a10.481,10.481,0,0,0,0-14.805,1.309,1.309,0,1,0-1.851,1.851,7.862,7.862,0,0,1,0,11.1,1.309,1.309,0,1,0,1.851,1.851",
    transform: "translate(-138.494 -84.17)",
    fill: "#9d9d9c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.771,118.547a1.308,1.308,0,0,0,0-1.851,7.862,7.862,0,0,1,0-11.1,1.309,1.309,0,1,0-1.851-1.851,10.481,10.481,0,0,0,0,14.805,1.308,1.308,0,0,0,1.851,0",
    transform: "translate(-69.919 -84.17)",
    fill: "#9d9d9c"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.932,
    cy: 3.932,
    r: 3.932,
    transform: "translate(22.471 23.043)",
    fill: "#9d9d9c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.471 23.043)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.863,
    height: 7.863,
    fill: "#f19117"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1101.387 268.045)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -2.91)",
    filter: "url(#o)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.527,0a20,20,0,0,1,17.321,10l54.48,94.381a20,20,0,0,1,0,20l-54.48,94.381a20,20,0,0,1-17.321,10H77.573a20,20,0,0,1-17.321-10L5.772,124.38a20,20,0,0,1,0-20L60.252,10A20,20,0,0,1,77.573,0Z",
    transform: "translate(237.76 2.91) rotate(90)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(43.573 190.33)",
    fill: "#9d9d9c",
    fontSize: 14,
    fontFamily: "ArialMT, Arial"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A MLDevOps Delivery")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(43.742 93.768)",
    fill: "#f19117",
    fontSize: 25,
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Zenselytics")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(77.234 135.789)",
    fill: "rgba(33,33,33,0.87)",
    fontSize: 16,
    fontFamily: "ArialMT, Arial"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "AI-enabled")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(47.011 153.789)",
    fill: "rgba(33,33,33,0.87)",
    fontSize: 16,
    fontFamily: "ArialMT, Arial"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Predictive Analytics"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1390.23 527.438)",
    fill: "#fff",
    fontSize: 31,
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A Zense")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1394.794 563.438)",
    fill: "#fff",
    fontSize: 31,
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Service")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1519.253 450.547)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.586,
    cy: 39.232,
    rx: 39.586,
    ry: 39.232,
    transform: "translate(0 0)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.825 13.046)",
    clipPath: "url(#q)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.4,105.436h-6.572a.411.411,0,0,1,0-.822H111.4a2.465,2.465,0,1,0,0-4.929l-.153.017a.417.417,0,0,1-.347-.153.411.411,0,0,1-.075-.371,4.1,4.1,0,0,0-5.764-4.813.413.413,0,0,1-.334.014.407.407,0,0,1-.233-.24,5.338,5.338,0,0,0-6.821-3.173.411.411,0,1,1-.279-.773,6.159,6.159,0,0,1,7.7,3.258,4.853,4.853,0,0,1,1.785-.338,4.934,4.934,0,0,1,4.929,4.929,4.837,4.837,0,0,1-.074.839,3.286,3.286,0,0,1-.337,6.555m-16.019,0H94.146a4.1,4.1,0,0,1-.682-8.146,6.192,6.192,0,0,1-.14-1.3,6.123,6.123,0,0,1,1.144-3.577.411.411,0,0,1,.669.478,5.3,5.3,0,0,0-.991,3.1,5.379,5.379,0,0,0,.228,1.541A.41.41,0,0,1,94,98.06a3.28,3.28,0,0,0,.147,6.556h1.232a.411.411,0,1,1,0,.822",
    transform: "translate(-73.092 -72.92)",
    fill: "#9d9d9c",
    stroke: "#9d9d9c",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.4,105.436h-6.572a.411.411,0,0,1,0-.822H111.4a2.465,2.465,0,1,0,0-4.929l-.153.017a.417.417,0,0,1-.347-.153.411.411,0,0,1-.075-.371,4.1,4.1,0,0,0-5.764-4.813.413.413,0,0,1-.334.014.407.407,0,0,1-.233-.24,5.338,5.338,0,0,0-6.821-3.173.411.411,0,1,1-.279-.773,6.159,6.159,0,0,1,7.7,3.258,4.853,4.853,0,0,1,1.785-.338,4.934,4.934,0,0,1,4.929,4.929,4.837,4.837,0,0,1-.074.839,3.286,3.286,0,0,1-.337,6.555Zm-16.019,0H94.146a4.1,4.1,0,0,1-.682-8.146,6.192,6.192,0,0,1-.14-1.3,6.123,6.123,0,0,1,1.144-3.577.411.411,0,0,1,.669.478,5.3,5.3,0,0,0-.991,3.1,5.379,5.379,0,0,0,.228,1.541A.41.41,0,0,1,94,98.06a3.28,3.28,0,0,0,.147,6.556h1.232a.411.411,0,1,1,0,.822Z",
    transform: "translate(-73.092 -72.92)",
    fill: "#9d9d9c",
    stroke: "#9d9d9c",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.745,136.247h-4.107a.411.411,0,1,1,0-.822h4.107a2.056,2.056,0,0,0,2.054-2.054v-5.179a.411.411,0,1,1,.821,0v5.179a2.878,2.878,0,0,1-2.875,2.875",
    transform: "translate(-94.351 -103.731)",
    fill: "#9d9d9c",
    stroke: "#9d9d9c",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.745,136.247h-4.107a.411.411,0,1,1,0-.822h4.107a2.056,2.056,0,0,0,2.054-2.054v-5.179a.411.411,0,1,1,.821,0v5.179A2.878,2.878,0,0,1,120.745,136.247Z",
    transform: "translate(-94.351 -103.731)",
    fill: "#9d9d9c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.475,129.835a.413.413,0,0,1-.291-.12l-.941-.942-.941.941a.411.411,0,0,1-.581-.581l1.232-1.232a.411.411,0,0,1,.581,0l1.232,1.232a.411.411,0,0,1-.291.7",
    transform: "translate(-117.385 -103.731)",
    fill: "#9d9d9c",
    stroke: "#9d9d9c",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.475,129.835a.413.413,0,0,1-.291-.12l-.941-.942-.941.941a.411.411,0,0,1-.581-.581l1.232-1.232a.411.411,0,0,1,.581,0l1.232,1.232a.411.411,0,0,1-.291.7Z",
    transform: "translate(-117.385 -103.731)",
    fill: "#9d9d9c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.556,180.619a.411.411,0,0,1-.411-.411v-8.943a2.878,2.878,0,0,1,2.875-2.875h.822a.411.411,0,1,1,0,.822h-.822a2.056,2.056,0,0,0-2.054,2.054v8.943a.411.411,0,0,1-.411.411",
    transform: "translate(-122.697 -136.697)",
    fill: "#9d9d9c",
    stroke: "#9d9d9c",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.556,180.619a.411.411,0,0,1-.411-.411v-8.943a2.878,2.878,0,0,1,2.875-2.875h.822a.411.411,0,1,1,0,.822h-.822a2.056,2.056,0,0,0-2.054,2.054v8.943a.411.411,0,0,1-.41.41Z",
    transform: "translate(-122.697 -136.697)",
    fill: "#9d9d9c",
    stroke: "#9d9d9c",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.24,224.506a.413.413,0,0,1-.291-.12l-1.232-1.232a.411.411,0,1,1,.581-.581l.941.941.941-.941a.411.411,0,0,1,.581.581l-1.232,1.232a.406.406,0,0,1-.289.12Z",
    transform: "translate(-117.381 -180.584)",
    fill: "#9d9d9c",
    stroke: "#9d9d9c",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.24,224.506a.413.413,0,0,1-.291-.12l-1.232-1.232a.411.411,0,1,1,.581-.581l.941.941.941-.941a.411.411,0,0,1,.581.581l-1.232,1.232a.406.406,0,0,1-.289.12Z",
    transform: "translate(-117.381 -180.584)",
    fill: "#9d9d9c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.26 29.215)",
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.225,
    height: 5.225,
    fill: "#f19117"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.825 13.046)",
    clipPath: "url(#q)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.713,24.013a3.347,3.347,0,0,0-1.246-.746A24.157,24.157,0,0,1,11.058,9.258a24.5,24.5,0,0,1,40.22,7.282.851.851,0,1,0,1.637-.462h0L52.9,16.04a.884.884,0,0,0-.038-.087A26.19,26.19,0,0,0,9.837,8.09,25.824,25.824,0,0,0,2.782,23.141a3.343,3.343,0,0,0-1.846.979,3.379,3.379,0,1,0,4.777-.107m-3.5,3.663A1.689,1.689,0,1,1,4.6,27.622a1.689,1.689,0,0,1-2.387.054",
    fill: "#9d9d9c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.323,126.437a3.343,3.343,0,0,0,1.846-.979,3.408,3.408,0,1,0-3.531.853,24.154,24.154,0,0,1-6.591,14.009,24.5,24.5,0,0,1-40.255-7.362.851.851,0,1,0-1.551.667,26.19,26.19,0,0,0,43.027,7.863,25.822,25.822,0,0,0,7.055-15.05m-1.764-2.093a1.689,1.689,0,1,1,2.388-.053,1.689,1.689,0,0,1-2.388.053",
    transform: "translate(-19.584 -97.207)",
    fill: "#9d9d9c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.33,55.867a18.658,18.658,0,0,0-3.388-2.57.851.851,0,1,0-.9,1.43A16.908,16.908,0,0,1,150.7,80.971a16.684,16.684,0,0,1-8.924,4.881,3.34,3.34,0,0,0-.855-1.377,3.4,3.4,0,1,0,.978,3.071,18.356,18.356,0,0,0,10.021-5.408,18.6,18.6,0,0,0-.588-26.271M137.416,88.138a1.689,1.689,0,1,1,2.388-.053,1.689,1.689,0,0,1-2.388.053",
    transform: "translate(-109.727 -43.111)",
    fill: "#9d9d9c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.336,64.532a.851.851,0,1,0,.877-1.443,16.908,16.908,0,0,1-3.719-26.282,16.684,16.684,0,0,1,8.924-4.881,3.341,3.341,0,0,0,.855,1.377,3.4,3.4,0,1,0-.978-3.071A18.356,18.356,0,0,0,59.274,35.64a18.593,18.593,0,0,0,4.062,28.893M73.775,29.64a1.689,1.689,0,1,1-2.388.053,1.689,1.689,0,0,1,2.388-.053",
    transform: "translate(-43.942 -22.295)",
    fill: "#9d9d9c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.612,0A2.612,2.612,0,1,1,0,2.612,2.612,2.612,0,0,1,2.612,0Z",
    transform: "translate(20.435 16.169)",
    fill: "#f19117"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.254 19.376)",
    clipPath: "url(#t)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.814,
    height: 6.821,
    transform: "matrix(0.691, -0.723, 0.723, 0.691, -2.584, 2.458)",
    fill: "#f19117"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.445 54.617)",
    clipPath: "url(#u)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.814,
    height: 6.821,
    transform: "matrix(0.691, -0.723, 0.723, 0.691, -2.584, 2.458)",
    fill: "#f19117"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.732 36.727)",
    clipPath: "url(#v)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.814,
    height: 6.821,
    transform: "matrix(0.691, -0.723, 0.723, 0.691, -2.584, 2.458)",
    fill: "#f19117"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.967 37.266)",
    clipPath: "url(#w)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.814,
    height: 6.822,
    transform: "matrix(0.691, -0.723, 0.723, 0.691, -2.584, 2.458)",
    fill: "#f19117"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1298.143 449.299)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37.929,
    cy: 37.929,
    r: 37.929,
    transform: "translate(0 0)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.67 16.633)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#x)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.355,279.257a1.225,1.225,0,0,1-.561-1.193c.026-1.052,0-2.1.009-3.157,0-.754.3-1.049,1.064-1.05h9.781V267.23c0-.74.29-1.027,1.034-1.029,1.078,0,2.156.02,3.234-.009a1.123,1.123,0,0,1,1.13.588v12.478Zm14.011-11.368h-2.057v6.544c0,.822-.269,1.087-1.1,1.087h-9.714v2.043h12.872Z",
    transform: "translate(-210.529 -236.665)",
    fill: "#9d9d9c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.046,12.478a1.124,1.124,0,0,1-1.13.588c-1.091-.029-2.183-.006-3.275-.01-.685,0-.991-.307-.992-.987V5.4H237.91c-.814,0-1.1-.285-1.107-1.092,0-1.038.017-2.077-.008-3.115A1.223,1.223,0,0,1,237.355,0h15.692ZM238.487,3.737h9.49c1.161,0,1.33.172,1.33,1.355v6.274h2.046V1.681H238.487Z",
    transform: "translate(-210.529)",
    fill: "#9d9d9c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.717,0a1.223,1.223,0,0,1,.561,1.2c-.026,1.011-.007,2.023-.008,3.034,0,.9-.267,1.172-1.153,1.172H5.424V12c0,.768-.286,1.055-1.05,1.057H1.014c-.68,0-.987-.311-.987-.995q0-5.527-.008-11.056A1.067,1.067,0,0,1,.607,0Zm-14,1.679v9.693H3.764V4.837c0-.83.266-1.1,1.087-1.1h9.732V1.679Z",
    transform: "translate(-0.017)",
    fill: "#9d9d9c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.59,279.326A1.132,1.132,0,0,1,0,278.2c.017-3.616.009-7.232.009-10.849,0-.8.278-1.077,1.071-1.078H4.4c.708,0,1.007.3,1.008,1.014v6.642H15.1c.887,0,1.152.27,1.153,1.172,0,1.011-.018,2.023.008,3.034a1.226,1.226,0,0,1-.561,1.2ZM1.7,267.942v9.689H14.565v-2.042H4.8c-.767,0-1.048-.284-1.049-1.054v-6.592Z",
    transform: "translate(0 -236.734)",
    fill: "#9d9d9c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.182,97.12a18.064,18.064,0,0,1-8.858-2.578A35.469,35.469,0,0,1,8.97,86.537c-.646-.758-1.248-1.554-1.854-2.346a.837.837,0,0,1,0-1.207A37.343,37.343,0,0,1,18.18,72.718a18.17,18.17,0,0,1,8.3-2.635,16.475,16.475,0,0,1,7.72,1.581,30.374,30.374,0,0,1,8.731,6.246,40.267,40.267,0,0,1,4.321,4.99.921.921,0,0,1,0,1.38A37.244,37.244,0,0,1,36.121,94.532a17.889,17.889,0,0,1-8.938,2.588m.292-1.663c.263-.021.789-.043,1.31-.105a17.4,17.4,0,0,0,6.852-2.467,36.02,36.02,0,0,0,9.894-9.062.324.324,0,0,0-.027-.5c-1.356-1.515-2.643-3.1-4.078-4.536a26.377,26.377,0,0,0-8.374-5.8,14.556,14.556,0,0,0-6.5-1.243,16.049,16.049,0,0,0-6.782,2A35.134,35.134,0,0,0,8.9,83.354a.329.329,0,0,0,.024.5c.5.606.983,1.236,1.5,1.83a33.063,33.063,0,0,0,9.2,7.667,16.335,16.335,0,0,0,7.853,2.108",
    transform: "translate(-6.097 -62.292)",
    fill: "#9d9d9c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.135,100.919a10.129,10.129,0,0,1,5.274,1.531.876.876,0,0,1,.386,1.357,1.447,1.447,0,0,0,1.889,2.007.868.868,0,0,1,1.3.463,10.015,10.015,0,1,1-10.412-5.209c.516-.089,1.044-.1,1.567-.149m7.634,6.676c-.052-.017-.066-.027-.078-.025a3.118,3.118,0,0,1-3.662-3.722c.063-.25-.066-.314-.238-.4a8.073,8.073,0,0,0-5.13-.706,8.41,8.41,0,1,0,9.824,8.783,8.16,8.16,0,0,0-.717-3.933",
    transform: "translate(-89.021 -89.726)",
    fill: "#9d9d9c"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.457 12.767)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3.876)",
    clipPath: "url(#y)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.312,
    height: 9.312,
    fill: "#f19117"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.829)",
    clipPath: "url(#z)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.36,
    height: 5.36,
    fill: "#f19117"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIamge);
export default __webpack_public_path__ + "static/media/Home_iamge.b5fbcfabfed5241365abc8d854b06059.svg";
export { ForwardRef as ReactComponent };